import React from "react";
import { Search } from "lucide-react";
import CourseCard from "./CourseCard";
import SiteMasthead from "@/cms/SiteMasthead";

/**
 * @param {{
 *   courses: Array<{
 *     id: string | number;
 *     name: string;
 *     city: string;
 *     country: string;
 *     image: string;
 *     description: string;
 *     price: number;
 *     amenities: string[];
 *     available_times: string[];
 *     fees_included: string[];
 *     images: string[];
 *   }>;
 *   onSelectCourse: (course: any) => void;
 *   isLoading?: boolean;
 *   title?: string;
 * }} props
 */

export default function SearchView({
  courses,
  onSelectCourse,
  isLoading = false,
  title = "About Our Courses",
}) {
  return (
    <div className="min-h-screen bg-white">
      <SiteMasthead pageKey="about-courses-masthead" />

      <div className="px-4 py-12 bg-white">
        <div className="max-w-6xl mx-auto">
          {isLoading ? (
            <div className="text-center py-16">
              <p className="text-muted-foreground">Loading golf courses...</p>
            </div>
          ) : (
            <>
              <p className="text-sm text-gray-400 mb-6">
                Showing {courses.length} available course{courses.length !== 1 ? "s" : ""}
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {courses.map((course, index) => (
                  <CourseCard
                    key={course.id}
                    course={course}
                    onSelect={onSelectCourse}
                    index={index}
                  />
                ))}
              </div>
              {courses.length === 0 && (
                <div className="text-center py-16">
                  <Search className="h-10 w-10 text-muted-foreground mx-auto mb-3" />
                  <p className="text-muted-foreground">No courses found</p>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
